module.exports = __webpack_public_path__ + "static/media/vip.93b1fcd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/vip.png
// module id = 570
// module chunks = 0